import { render } from "./TabPosition.vue?vue&type=template&id=0886afb7"
import script from "./TabPosition.vue?vue&type=script&lang=js"
export * from "./TabPosition.vue?vue&type=script&lang=js"
script.render = render

export default script